// Language-aware routing utilities

export const routes = {
  tr: {
    home: '/',
    corporateEvents: '/kurumsaletkinlik',
    about: '/hakkimizda',
    kvkk: '/kvkk',
    privacyPolicy: '/gizlilik-politikasi',
    admin: '/adminboraorkun',
    influencer: '/influencer-kayit'
  },
  en: {
    home: '/en',
    corporateEvents: '/en/corporate-events',
    about: '/en/about',
    // KVKK sadece TR'de — EN için Privacy Policy var
    privacyPolicy: '/en/privacy-policy',
    admin: '/en/adminboraorkun',
    influencer: '/en/influencer-registration'
  }
};

// Get route path based on language
export const getRoute = (routeKey, language) => {
  return routes[language][routeKey] || routes.tr[routeKey];
};

// Get current language from URL
export const getLanguageFromURL = (pathname) => {
  return pathname.startsWith('/en') ? 'en' : 'tr';
};

// Remove language prefix from URL to match component routes
export const getCleanPath = (pathname) => {
  if (pathname.startsWith('/en')) {
    const cleanPath = pathname.replace(/^\/en/, '');
    return cleanPath || '/';
  }
  return pathname;
};
